import { Component, ViewChild } from '@angular/core';
import { GruposPage } from '../pages/grupos/grupos';
import { Platform, Nav, App } from 'ionic-angular';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  @ViewChild(Nav) nav: Nav;
  rootPage: any = GruposPage;

  constructor(
    public platform: Platform,
    public app: App
  ) {
    platform.ready().then(()=>{
      platform.registerBackButtonAction(()=>{
        let nav = this.app.getActiveNavs()[0];
        let activeView = nav.getActive();  

        // Checks if can go back before show up the alert
        if(activeView.name == 'ListarComandaPage' || activeView.name == 'AdicionarProdutoPage') {
          this.nav.setRoot(GruposPage);          
        }else{
          if (nav.canGoBack()){
            return false
            // nav.pop();
          }          
        }        
      })
    })
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts